import React from 'react';
import './PageLayout.css';

const PageLayout = ({ children, title, subtitle, eyebrow, actions = null }) => {
  // CRITICAL: Only render hero if props are EXPLICITLY provided
  const shouldShowHero = !!title || !!subtitle || !!actions || !!eyebrow;

  return (
    <div className="page-layout">
      {shouldShowHero && (
        <div className="page-toolbar">
          <div className="toolbar-title">
            {title && <h1>{title}</h1>}
          </div>
          <div className="toolbar-actions">
            {actions && <div className="page-actions-container">{actions}</div>}
          </div>
        </div>
      )}
      <div className="page-content-wrapper">{children}</div>
    </div>
  );
};

export default PageLayout;

